import { cva } from '@/styled-system/css';

export const alertBodyRecipe = cva({
  base: {
    flex: '1',
    textStyle: 'body',
  },
  variants: {
    tone: {
      critical: { color: 'text.neutral' },
      info: { color: 'text.neutral' },
      success: { color: 'text.neutral' },
      warning: { color: 'text.neutral' },
    },
  },
});
